export default "__VITE_ASSET__ySQgpGku__"